import z from "zod";

export const getParscCalculationParamSchema = z.object({
	referenceId: z.uuid(),
});

export type GetParscCalculationParamSchema = z.infer<typeof getParscCalculationParamSchema>;
